import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ listAndNotesSelectedArray: string[] }>;

const DispatchPackingListNotesAndInstruction: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetPackingListNotesAndInstruction",
        packingAndInstructions: props.parameter.listAndNotesSelectedArray,
    });
};

export const chain = [DispatchPackingListNotesAndInstruction];

const packingListNotesAndInstructions = createHandlerChainRunner(chain, "PackingListNotesAndInstructionHandler");
export default packingListNotesAndInstructions;
